import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';

const List = ({ isReadonly, onDelete, t, ...rest }) => {
	const columns = [
		{
			header: t('TrialLesson_Child'),
			accessor: 'child',
			sortable: true,
			cell: (id, row) => <Link to={`/parents/${row.child.parentId}/children/${row.child.id}`}>{row.child.name}</Link>
		},
		{
			header: t('TrialLesson_Grade'),
			accessor: 'weeklyProgram',
			sortable: true
		},
		{
			header: t('TrialLesson_Date'),
			accessor: 'lessonDate',
			cell: (lessonDate) => (ui.formatDate(lessonDate)),
			sortable: true
		},
		{
			header: t('TrialLesson_IsAttended'),
			accessor: 'isAttended',
			cell: (isAttended) => (ui.formatBoolean(isAttended)),
			sortable: true
		}
	];
	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);